module.exports = __webpack_public_path__ + "static/media/roto_xcx.b62f301f.jpg";